
import React from "react";
import MobileUpdatesDrawer from "./MobileUpdatesDrawer";

interface MobileMenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

export default function MobileMenuButton({ isOpen, onClick }: MobileMenuButtonProps) {
  return (
    <div className="lg:hidden flex items-center">
      <MobileUpdatesDrawer />
      
      <button
        className="flex flex-col justify-center items-center w-10 h-10 rounded-md focus:outline-none ml-2"
        onClick={onClick}
        aria-label={isOpen ? "Close menu" : "Open menu"}
      >
        <span
          className={`block w-5 h-0.5 bg-gray-800 transition-all duration-300 ease-out ${
            isOpen ? "rotate-45 translate-y-1" : ""
          }`}
        ></span>
        <span
          className={`block w-5 h-0.5 bg-gray-800 mt-1 transition-all duration-300 ease-out ${
            isOpen ? "opacity-0" : ""
          }`}
        ></span>
        <span
          className={`block w-5 h-0.5 bg-gray-800 mt-1 transition-all duration-300 ease-out ${
            isOpen ? "-rotate-45 -translate-y-1" : ""
          }`}
        ></span>
      </button>
    </div>
  );
}
